import createHydrationObserver from './create-observer';
import removeInteractionEvents from './remove-interaction-events';

let hydrationObserver = null;

export default function($element, hydrationType, hydrationWrapperFn) {
    switch (hydrationType) {
        case 'immediate':
            hydrationWrapperFn();

            break;

        case 'onInteraction':
            const eventListenerOptions = {
                capture: true,
                once: true,
                passive: true,
            };

            const interactionEvents = $element.dataset.interactionEvents.split(' ');

            if (interactionEvents.length) {
                const moduleEvents = interactionEvents[$element.hydrationState.onInteraction] || interactionEvents[0];
                const eventsArray = moduleEvents.split('|');

                for (const eventName of eventsArray) {
                    const handleInteraction = () => {
                        hydrationWrapperFn();
                        removeInteractionEvents(eventsArray, $element, handleInteraction, eventListenerOptions);
                    };

                    $element.addEventListener(eventName, handleInteraction, eventListenerOptions);
                }

                $element.hydrationState.onInteraction++;
            }

            break;

        case 'onGlobalEvent':
            const globalEvents = $element.dataset.globalEvents.split(' ');

            if (globalEvents.length) {
                const moduleEvent = globalEvents[$element.hydrationState.onGlobalEvent] || globalEvents[0];
                const handleEvent = () => {
                    hydrationWrapperFn();
                    window.removeEventListener(moduleEvent, handleEvent);
                };

                window.addEventListener(moduleEvent, handleEvent);
                $element.hydrationState.onGlobalEvent++;
            }

            break;

        default: /* whenVisible */
            if (!hydrationObserver) {
                hydrationObserver = createHydrationObserver();

                // no support for IntersectionObserver = hydrate immediately
                if (!hydrationObserver) {
                    hydrationWrapperFn();

                    return;
                }
            }

            $element.hydrationState.hydrationQueue.push(hydrationWrapperFn);
            hydrationObserver.observe($element);
    }
}